import React from 'react';
import { TrendingWordsShape } from '../shapes';
import MostTackedWord from './most_tacked_word';
import PropTypes from 'prop-types';
import Waiting from '../components/waiting';

export default class AllMostTackedWords extends React.Component {
  static propTypes = {
    trendsObject: TrendingWordsShape,
    onFetchMostTackedWords: PropTypes.func
  }

  componentDidMount() {
    this.props.onFetchMostTackedWords(50);
  }

  render() {
    if (this.props.trendsObject.get('mostTackedWords').size > 0) {
      return this.renderMostTackedWords();
    } else {
      return this.renderCrunching();
    }
  }

  renderMostTackedWords() {
    const mostTackedWords = this.props.trendsObject.get('mostTackedWords').map((newestWord, i) => {
      return (
        <li key={ i }><MostTackedWord trendingWord={ newestWord }/></li>
      );
    });

    return(
      <div className='all-trending-words'>
        <h1>Most Tacked</h1>
        <p>Yak Tack's most popular words this month.</p>
        <ol>{ mostTackedWords }</ol>
      </div>
    );
  }

  renderCrunching() {
    return(<Waiting />);
  }
}



// WEBPACK FOOTER //
// ./src/components/all_most_tacked_words.jsx